import { formatNumber } from '@angular/common';
import pptxgen from 'pptxgenjs';
import { AbinResultDto } from 'src/app/inge-api/abinclient/models';
import { _andelBarchartOptions } from '../slide-components/_andelBarchart';
import addBanner from '../slide-components/_banner';
import { sammanvagningCardOptions } from '../slide-components/_sammanvagningCard';
import { getComboChartOptions, getComboTypes } from '../pptx-chart-utils';
import { getYAxisMaxValueFromList } from '../../../google-charts/google-chart-utils';

export default (slide: pptxgen.Slide, inventeringar: AbinResultDto[], chartImg: string) => {
    addBanner(slide, {
        header: 'Konkurrensstatus för rönn, asp, sälg och ek (RASE)',
        text: 'Målet är att förekomsten av RASE är 400 stammar per hektar och att 10 procent av dessa har gynnsam status. Om andelen mager mark i området är stor (>40%) så är målet 200 stammar per hektar varav 5 procent har gynnsam status.'
    });
    const senasteInventering = inventeringar[0];

    const comboTypes = getComboTypes(inventeringar, 'antalRASEGynnsamHa', 'antalRASEGynnsamHa3InvAVG');
    const maxValue = getYAxisMaxValueFromList([...comboTypes[0].data[0].values, ...comboTypes[1].data[0].values]);
    const comboOptions = getComboChartOptions('Andel av inventerade ytor i ungskog där RASE har gynnsam status', maxValue);

    slide
        .addImage({
            data: chartImg,
            x: 0.5,
            y: 1.5,
            w: 9,
            h: 5
        })
        .addText('Felmarginal visas med felstaplar samt en ljusblå zon. Definition för felmarginal finns längst ner i rapporten.', {
            w: 8,
            h: 0.5,
            x: 1,
            y: 6.2,
            fontSize: 8,
            bold: false,
            align: 'center',
            valign: 'top'
        })
        .addShape('rect', sammanvagningCardOptions())
        .addImage({
            path:
                senasteInventering.slutsatsRASEGynInt > 0
                    ? 'assets/abin-icons-png/Rase_gynnsam_status_uppfylld-2022.svg'
                    : 'assets/abin-icons-png/Rase_gynnsam_status_ej_uppfylld-2022.svg',
            sizing: { type: 'cover', w: 1.13, h: 1.18 },
            x: 10.69,
            y: 2.39
        })
        .addText(formatNumber(senasteInventering.antalRASEGynnsamHa3InvAVG, 'sv-se', '1.0-1'), {
            h: 0.91,
            w: 2.83,
            x: 9.77,
            y: 3.47,
            fontSize: 48,
            bold: true,
            align: 'center'
        })
        .addText(' RASE med gynnsam status per hektar. Sammanvägning för de tre senaste inventeringarna', {
            w: 2.83,
            x: 9.77,
            h: 0.81,
            y: 4.38,
            fontSize: 14,
            bold: false,
            align: 'center',
            valign: 'top'
        });
};
